import { Any, JsonConvert, JsonConverter, JsonCustomConvert, JsonObject, JsonProperty } from "json2typescript";
import { BaseResponse } from "../base-response";

@JsonConverter
export class DeviceAccountArrayConverter implements JsonCustomConvert<Array<DeviceAccount>> {
	serialize() { }
	deserialize(data: any): Array<DeviceAccount> {
		const jsonConvert: JsonConvert = new JsonConvert();
		return jsonConvert.deserializeArray(data, DeviceAccount);
	}
}
@JsonConverter
export class DeviceAccountConverter implements JsonCustomConvert<DeviceAccount> {
	serialize() { }
	deserialize(data: any): DeviceAccount {
		const jsonConvert: JsonConvert = new JsonConvert();
		return jsonConvert.deserializeObject(data, DeviceAccount);
	}
}

@JsonObject("DeviceAccount")
export class DeviceAccount {
	@JsonProperty("username", String, true)
	username: string = "";
	// @JsonProperty("enabled", Boolean, true)
	// enabled: boolean = false;
	@JsonProperty("channel", String, true)
	channel: string = "";
	@JsonProperty("os_version", String, true)
	os_version: string = "";
	@JsonProperty("mac", String, true)
	mac: string = "";
	@JsonProperty("last_update", Number, true)
	last_update: number = 0;
	@JsonProperty("created_at", Number, true)
	created_at: number = 0;
	@JsonProperty("valid_since", Number, true)
	valid_since: number = 0;
	@JsonProperty("valid_until", Number, true)
	valid_until: number = 0;
	@JsonProperty("expand", Boolean, true)
	expand: boolean = false;
	@JsonProperty("status", String, true)
	status: string = "";
	@JsonProperty("identity_email", String, true)
	identity_email: string = "";
}

@JsonObject("DeviceAccountArray")
export class DeviceAccountArray extends BaseResponse {
	@JsonProperty("data", DeviceAccountArrayConverter, true)
	data: DeviceAccount = new DeviceAccount();
}